import React from "react";
import SvgIcon, { SvgIconProps } from "../SvgIcon";
import { default as RocketIconSrc } from '../assets/rocket.svg';

export const RocketIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox='-8 -8 32 32' >
    <RocketIconSrc />
  </SvgIcon>
);